export default __webpack_public_path__ + "static/media/Gb4.29fa5776.mp3";